var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-date",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 28,
    height: 28,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M20.445,24H2.555A2.544,2.544,0,0,1,0,21.474V5.052A2.544,2.544,0,0,1,2.555,2.526H3.833V.632A.636.636,0,0,1,4.472,0H5.75a.636.636,0,0,1,.639.632V2.526H16.611V.632A.636.636,0,0,1,17.25,0h1.278a.636.636,0,0,1,.639.632V2.526h1.278A2.544,2.544,0,0,1,23,5.052V21.474A2.544,2.544,0,0,1,20.445,24ZM2.555,7.579V21.474H20.445V7.579ZM17.25,17.685H15.972a.636.636,0,0,1-.639-.632V15.79a.636.636,0,0,1,.639-.632H17.25a.636.636,0,0,1,.639.632v1.263A.636.636,0,0,1,17.25,17.685Zm-5.111,0H5.75a.636.636,0,0,1-.639-.632V15.79a.636.636,0,0,1,.639-.632h6.389a.636.636,0,0,1,.638.632v1.263A.636.636,0,0,1,12.139,17.685Zm5.111-5.053H10.861A.635.635,0,0,1,10.222,12V10.736a.635.635,0,0,1,.638-.631H17.25a.636.636,0,0,1,.639.631V12A.636.636,0,0,1,17.25,12.632Zm-10.222,0H5.75A.636.636,0,0,1,5.111,12V10.736a.636.636,0,0,1,.639-.631H7.028a.636.636,0,0,1,.639.631V12A.636.636,0,0,1,7.028,12.632Z",
    transform: "translate(3 2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon-date.8ba279bb0060f5130068aad3534b70a3.svg";
export { ForwardRef as ReactComponent };